import { render, staticRenderFns } from "./HuiWo.vue?vue&type=template&id=62473aec&scoped=true&"
import script from "./HuiWo.vue?vue&type=script&lang=js&"
export * from "./HuiWo.vue?vue&type=script&lang=js&"
import style0 from "./HuiWo.vue?vue&type=style&index=0&id=62473aec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62473aec",
  null
  
)

export default component.exports